module.exports = __webpack_public_path__ + "img/only-shadow.ffc0ad3f.svg";